module.exports = __webpack_public_path__ + "whiteflowerarranged.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/whiteflowerarranged.png
// module id = 888
// module chunks = 0